import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { AuthProvider } from "../modules/auth/AuthContext";
import { Provider } from "react-redux";
import store from "../store/timerStore";

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <Provider store={store}>
      <AuthProvider>
        
          <App />
        
      </AuthProvider>
    </Provider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
